var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classnames from 'classnames';
import noop from 'lodash/noop';
import { Close as IconClose, CustomCheckCircle1, CustomInfoCircle, CustomAlertDiamond, } from '@fil-react-components/svg-icons';
import withStyles from '@fil-react-components/with-styles';
import Paragraph from '@fil-react-components/paragraph';
import Anchor from '@fil-react-components/anchor';
import { BaseButton } from '@fil-react-components/button';
import StreamlineIcon from '@fil-react-components/streamline-icon';
import styles, { statusColors } from './Notification.style';
const getStatusIcon = (status) => {
    switch (status) {
        case 'success':
            return CustomCheckCircle1;
        case 'warning':
            return CustomAlertDiamond;
        default:
            return CustomInfoCircle;
    }
};
const Notification = (_a) => {
    var { children, closable = true, onClose = noop, className, title, status = 'success', linkLabel, linkUrl, linkProps, showIcon = true } = _a, otherProps = __rest(_a, ["children", "closable", "onClose", "className", "title", "status", "linkLabel", "linkUrl", "linkProps", "showIcon"]);
    return (_jsxs("div", Object.assign({ className: classnames('fil-notification', className) }, otherProps, { children: [showIcon && (_jsx("div", Object.assign({ className: "fil-notification__icon" }, { children: _jsx(StreamlineIcon, { "aria-label": status, icon: getStatusIcon(status), filled: true, iconColor: statusColors[status] }) }))), _jsxs("div", Object.assign({ className: "fil-notification__body" }, { children: [closable && (_jsx(BaseButton, Object.assign({ ariaLabel: "close", className: "fil-notification__close", onClick: onClose }, { children: _jsx(StreamlineIcon, { icon: IconClose, size: 16 }) }))), title && _jsx(Paragraph, Object.assign({ className: "fil-notification__title" }, { children: title })), children && _jsx("div", Object.assign({ className: "fil-notification__text" }, { children: children })), linkLabel && (_jsx(Anchor, Object.assign({ display: "block", className: "fil-notification__link", href: linkUrl }, linkProps, { children: linkLabel })))] }))] })));
};
Notification.displayName = 'Notification';
export default withStyles(Notification, styles);
